export default {
  Fleet_Phase3_Other_mKWz: 'Más información',
  Fleet_check_hceA_ycnc: 'Entendido',
  Fleet_Phase2_Unable_to_ZEyJ:
    'No se pudo enviar la invitación porque este vehículo ya está vinculado con otro arrendador.',
  Fleet_Phase1_Refresh_successfully_sWTn:
    'Se actualizó el estado del vehículo y más arrendadores podrán verlo.',
  Fleet_check_fBNK_CTjZ:
    'Solo puedes invitar a arrendadores después de que se apruebe tu foto de perfil.',
  Fleet_Phase3__eugX: 'Ingresa la dirección completa',
  Fleet_Phase1_My_information_gZpd: 'Mi perfil',
  Fleet_Phase1_Management_laKS: 'Gestión',
  Fleet_Phase2_Unable_to_DjsM:
    'No se pudo enviar la invitación. Por favor, inténtalo de nuevo más tarde.',
  Fleet_Phase2_Not_read_oNht: 'No leídos',
  Fleet_Phase2_Invitation_binding_pNPg: 'Invitar',
  Fleet_Phase3__HBGE: 'Buscar dirección',
  Fleet_Phase1__day_TSlN: '{{day_num}} día(s)',
  Fleet_Phase2_Here_is_UUpu: '¿Te gustaría ver mi información?',
  Fleet_Phase1_Please_select_sHdy: 'Selecciona al menos uno',
  Fleet_Phase3__YASB: 'Dirección',
  Fleet_Phase1_Completed_lnTq: 'Completado',
  Fleet_Phase1_Select_from_vFPP: 'Elegir desde un álbum',
  Fleet_Phase2_Invitation_accepted_jUWV: 'Invitación aceptada',
  Fleet_6_Approved_iJNK: 'Aprobado',
  Fleet_Phase2_Select_a_IWnZ: 'Elige un vehículo',
  Fleet_Phase3__NQtB: 'No aprobada',
  Fleet_Phase1_Want_FfcG: 'Elegido',
  Fleet_Phase3_When_it_VfVv:
    'Al activar esta opción, los socios flotilla pueden ver tu información y contactarte.',
  Fleet_Phase1_Vehicle_Information_GKvX: 'Perfil del vehículo',
  Fleet_Phase1_Near_wiMy: 'Cercanos',
  Fleet_replenish__AsrC: 'Por favor, ingresa el nombre de la flotilla.',
  Fleet_Phase2_Unable_to_rFbW:
    'No se pudo enviar la invitación porque ya invitaste a este arrendador.',
  Fleet_Phase3_Please_fill_TwPJ: 'Ingresa un tipo de tarifa única',
  Fleet_Phase3_Cancel_lhJc: 'Cancelar',
  Fleet_Phase2_Sent_successfully_VMHB: 'Se envió correctamente.',
  Fleet_Phase1_Unfilled_information_shzk: 'Completa todos los campos obligatorios.',
  Fleet_Phase1_Refresh_vehicle_dBKn: 'Actualizar el estado del vehículo para atraer más vistas',
  Fleet_Phase1_Petrol_xPTk: 'Gasolina',
  Fleet_MatchingTool_Loading_ingu: 'Cargando',
  Fleet_Phase1_Select_the_TBEO: 'Elige la fecha más próxima disponible.',
  Fleet_Phase1_Pick_up_Fzqt: 'Dirección donde se recogerá el vehículo',
  Fleet_Phase3_Maintenance_costs_Arun: 'Tarifa de mantenimiento',
  Fleet_Phase3_Looking_for_mjCy: 'Buscar',
  Fleet_Phase2_Go_and_TKGq: 'Completar ahora',
  Fleet_Phase3_Fill_in_AwVF:
    'Cuéntales a los arrendadores acerca de ti y los servicios que brindas',
  Fleet_Phase3_Handling_address_Kuoh: 'Gestión de direcciones',
  Fleet_Phase1_Successfully_removed_Kfwm: 'Se eliminó correctamente.',
  Fleet_Phase3_To_protect_LYnV:
    'Por privacidad, usa este número virtual para hacer la llamada: {{phone_num}}.',
  Fleet_Phase2_Delete_OMUs: 'Eliminar',
  Fleet_Phase2_You_have_VdTt:
    'Invitación aceptada. Contacta a la flotilla para definir detalles del vehículo.',
  Fleet_Phase1_Successful_collection_cgRX: 'Se agregó a tus favoritos.',
  Fleet_Phase3_Allowing_for_dpCi: 'Hacer pública mi información',
  Fleet_Phase1_Driving_age_CGrZ: 'Tiempo conduciendo',
  Fleet_Phase1_Recommended_JWJE: 'Sugeridos',
  Fleet_Phase1_Yes_KnFJ: 'Sí',
  Fleet_replenish__Nkhy: 'No se pudo vincular.',
  Fleet_Phase1_There_are_TYqj: 'Aquí puedes buscar arrendadores.',
  Fleet_Phase2_Waiting_for_CtmY: 'Esperando respuesta del arrendador',
  Fleet_Phase1_Select_the_arPR: 'Elegir imágenes predeterminadas',
  Fleet_Phase2_Unable_to_mzyp:
    'No se pudo aceptar la invitación porque ya te agregó otra flotilla.',
  Fleet_Phase3__xiYg: 'Descarga la app de {{app_name}}',
  Fleet_Phase1_Edit_bifa: 'Editar',
  Fleet_Phase2_Confirmation_Amgz: 'Confirmar',
  Fleet_Phase1_Inactive_vehicles_oKjt: 'Inactivos',
  Fleet_Phase3__RlYg: 'La imagen no cumple los requisitos. Bórrala e inténtalo de nuevo.',
  Fleet_Phase1_Vehicle_market_bycj: 'Buscar vehículos',
  Fleet_Phase1_You_modified_ugEp: 'No se guardaron los cambios. ¿Seguro que deseas salir?',
  Fleet_Phase2_The_message_dvIE: 'Mensaje muy largo. Intenta ser más breve',
  Fleet_Phase1_Types_of_Dcxe: 'Servicios disponibles',
  Fleet_Phase3__sjZr: 'Activar ahora',
  Fleet_Phase2_Open_message_BjYw:
    'Para recibir mensajes y noticias, activa el permiso de notificaciones.',
  Fleet_Phase2_Sending_vehicles_VpWK: 'Enviar vehículo',
  Fleet_Phase1_On_the_Zuml: 'Agregados',
  Fleet_Phase1_Recommended_tZZU: 'Sugeridos',
  Fleet_Phase3_Looking_for_VBig: 'Buscar',
  Fleet_Phase1_Countless_counts_rEma: 'No hay datos disponibles',
  GDriver_Name_DiDi_Gsik: 'DiDi',
  Fleet_Phase1_Open_the_mLYO:
    'Ve a Configuración > Privacidad > Ubicación y activa el permiso para {{app_name}} Fleet.',
  Fleet_Phase3_Select_KUZn: 'Destacados',
  Fleet_Phase3_The_driver_lmIm: 'Los arrendadores te contactarán usando tu número real.',
  Fleet_Phase1_Please_enter_kMFd: 'Ingresa tu número de celular.',
  Fleet_Phase2_More_features_rGBL: 'Haz clic aquí para ver más funciones.',
  Fleet_deactivation_rxsN_avVX: 'Se quitó este vehículo',
  Fleet_Phase1_Vehicter_vehicles_KaSk: 'Agregar un vehículo',
  Fleet_Phase1_Fill_in_kRws:
    'Ingresa tu información personal para que la flotilla pueda conocerte y contactarte',
  'kfcommon-fe-i18n---common': {
    inpPlease: 'Favor de llenar'
  },
  Fleet_Phase1_Later_aaAa: 'Más tarde',
  Fleet_Resdesign_Enter_email_cylU: 'Ingresar correo',
  Fleet_Phase1_Management_Kglv: 'Gestión',
  Fleet_Phase1_Driver_Market_lUUD: 'Buscar arrendadores',
  Fleet_Phase3_Add_pickup_rHID: 'Agregar dirección',
  Fleet_Phase1_The_earliest_BMcv: 'Fecha de renta más próxima',
  Fleet_FleetRecommendation_Enter_the_Ykpv: 'Ingresa un monto válido',
  Fleet_Phase1_Vehicter_vehicles_cgyn: 'Agregar vehículo',
  Fleet_Phase1_Editing_your_VLmr: 'Editar información',
  Fleet_Phase1_Add_a_ZZNX: 'Agregar nuevo vehículo',
  Fleet_Phase1_Lower_vehicle_gEAa: 'Quitar vehículo',
  Fleet_Phase1_Are_mileage_hsVk: '¿El vehículo tiene un límite de kilometraje que puedo usar?',
  Fleet_Phase1_Add_other_TKWp: 'Agregar otras tarifas que apliquen por única vez',
  Fleet_Phase2_Invitation_expired_IedS: 'La invitación venció',
  Fleet_Phase1_The_driver_Ktpo:
    'Los arrendadores llamarán a un número virtual, así que no verán tu número real.',
  Fleet_Phase2_You_might_PnzM: 'Quizá quieras',
  Fleet_Phase1_Enter_the_CVAP: 'Ingresa el kilometraje del vehículo.',
  Fleet_Phase2_Cancel_UgrT: 'Cancelar',
  Fleet_Phase2_Your_resume_VFPE: 'Completa tu información',
  Fleet_Phase1_Do_you_jEQf: '¿El arrendador tiene un lugar para estacionarse?',
  Fleet_Phase1_Open_Location_yZxu: 'Permiso de ubicación',
  Fleet_deactivation_ZMOT_xRGi: 'Se quitaron estos vehículos:',
  Fleet_Phase2__Invite_AtyZ: '[Te invitó a su flotilla]',
  Fleet_Phase1_Automatic_file_EBVQ: 'Automática',
  Fleet_Phase1_Waiting_for_hAcD: 'Sin agregar',
  Fleet_Mgt_Pull_down_YzpV: 'Desliza hacia abajo y actualiza',
  Fleet_Phase1_Cities_with_FYWy: 'Ciudad disponible',
  Fleet_Phase1_Select_vehicle_eTyy: 'Seleccionar un vehículo',
  Fleet_Phase1_Weekly_rent_Qcao: 'Tarifa de alquiler semanal',
  Fleet_Phase2_Accept_the_SSyv: 'Invitación aceptada',
  Fleet_Phase1_Upload_vehicle_CJxH: 'Carga las fotos del vehículo',
  Fleet_Phase3_Insurance_UelD: 'Tarifa del seguro',
  Fleet_Phase1_Open_positioning_isUK:
    'Al activar el permiso de ubicación, podrás ver más información.',
  Fleet_Phase3_Delete_isuY: 'Eliminar',
  Fleet_Phase3_Select_city_OuhR: 'Selecciona una ciudad',
  Fleet_Phase1_No_somg: 'No',
  Fleet_Phase2__picture_dcAZ: '[Imagen]',
  Fleet_Phase2_Can_t_Ypzr: 'No se puede enviar un mensaje en blanco.',
  Fleet_Phase1_Lease_Information_AcRo: 'Información de la renta',
  Fleet_Phase2_Fill_in_HjMn:
    'Ingresa tu información personal para que la flotilla sepa más sobre ti.',
  Fleet_Phase1_Electric_OCNq: 'Eléctrico',
  Fleet_check_pajT_vPwq: 'Sube una foto de perfil',
  Fleet_Phase1_Confirmation_hXpq: 'Confirmar',
  Fleet_Phase3__ZyyO: '¿Seguro que quieres salir?',
  Fleet_Phase3__ZGux: 'Descarga la app de {{brand_name}}',
  Fleet_Phase1_Go_on_lQWv: 'Activar ahora',
  Fleet_Phase2_Are_you_tmbn: '¿Deseas aceptar la invitación?',
  Fleet_Phase2_Upon_acceptance_RppA:
    'Si aceptas, te unirás a la flotilla. Si deseas salir de ella, contacta al socio flotilla.',
  Fleet_Phase1_Display_MPQk: 'Mostrado',
  Fleet_Phase2_Send_your_boUl: 'Enviar información',
  Fleet_Phase3_Agree_GpZc: 'Aceptar',
  Fleet_Phase2_Are_you_pyUy:
    '¿Seguro que deseas bloquear a este arrendador? Si lo haces, no recibirás sus mensajes.',
  Fleet_Phase1_Location_hZax: 'Ubicación',
  Fleet_Phase1_My_resume_XrBM: 'Mi información',
  Fleet_Phase1_Introduce_more_wgzd:
    'Agrega más datos sobre el vehículo para aumentar las posibilidades de que lo renten.',
  Fleet_Phase2_Unable_to_BjVG:
    'No se pudo aceptar la invitación porque ya te invitó otra flotilla.',
  Fleet_Phase3__wuiT: 'Cancelar',
  Fleet_Phase3__cGjU: 'Enviar',
  Fleet_Phase2_Latin_America_mcWa: 'Bloquear',
  Fleet_Phase1_Open_the_qftm:
    'Ve a Configuración > Privacidad > Notificaciones y activa el permiso para {{app_name}} Fleet.',
  Fleet_Mgt_Loosen_immediately_OZaY: 'Suelta la pantalla y actualiza',
  Fleet_Phase2_The_invitation_cRjb:
    'La invitación venció. Pídele a la flotilla que vuelva a invitarte.',
  Fleet_MatchingTool_New_NygE: 'Nuevo',
  Fleet_Phase2_Message_uxVI: 'Mensajes',
  Fleet_Phase1_Mileage_Nbsu: 'Kilometraje del vehículo',
  Fleet_Phase1_Select_a_MUGc: 'Elige la ciudad que corresponda.',
  Fleet_Phase3__aLzi: 'Buscar número de placa o modelo',
  Fleet_Phase3_Disapproval_WwYC: 'Rechazar',
  Fleet_Phase1_Saved_ukpW: 'Favoritos',
  Fleet_Phase1_Near_GlZf: 'Cercanos',
  Fleet_Phase1_Fill_in_SDNM: 'Completar ahora',
  Fleet_Phase2_Camera_xPcX: 'Cámara',
  Fleet_Phase1_Contact_the_sCYy: 'Contactar al arrendador',
  Fleet_Phase1__trip_OWdz: '{{trip_num}} arrendamiento(s)',
  Fleet_Phase3_Set_ozBm: 'Configuración',
  Fleet_Phase1_Vehicles_fail_vWFT: 'No pudo agregarse el vehículo. Inténtalo de nuevo más tarde.',
  Fleet_Phase1_Credit_card_nkHX: 'Tarjeta de crédito',
  Fleet_replenish__YWZk: 'Nombre de la flotilla',
  Fleet_Phase1_Vehicle_mileage_JJmR: 'Kilometraje del vehículo',
  Fleet_Phase2_I_m_otcY: 'Vi el vehículo que publicaste. ¿Crees que podamos platicar?',
  Fleet_deactivation_vcXF_nzJK: 'Se quitaron estos vehículos:',
  Fleet_Phase3_Contact_number_gTtI: 'Número de contacto',
  Fleet_Drivers_Amount_YOtw: 'Monto',
  Fleet_Phase3_Urban_upMp: 'Ciudad',
  Fleet_Phase1_Select_the_DRmS: 'Elige un tipo de transmisión.',
  Fleet_Phase2_Album_HNuC: 'Álbum',
  Fleet_Phase3_Would_you_XJNH: '¿Seguro que deseas eliminar esta dirección?',
  Fleet_check_IYER_eDig:
    'Solo puedes vincular vehículos a arrendadores de tu flotilla después de que se apruebe tu foto de perfil.',
  Fleet_Phase3__wCFx: 'Cargada',
  Fleet_check_PFze_fown: 'Estamos revisando tu foto de perfil',
  Fleet_Phase1_Reset_ZyNB: 'Restablecer',
  Fleet_Phase1_Edit_IQWQ: 'Editar',
  Fleet_Phase1_Browse_HIWC: 'Visto',
  Fleet_Phase1_Payment_Method_fVJF: 'Método de pago preferido',
  Fleet_Phase1_Click_Change_LCrQ: 'Haz clic para editar',
  Fleet_Phase3_Cancel_flmb: 'Cancelar',
  Fleet_replenish__dJdA: '¡Ocurrió un error! Por favor, inténtalo de nuevo.',
  Fleet_Phase1_Next_step_OMuQ: 'Siguiente',
  Fleet_Phase1_Star_rating_jYxN: 'Calificación',
  Fleet_Phase2_Unable_to_ylbx:
    'No se pudo aceptar la invitación porque el estado del vehículo está vencido.',
  Fleet_Phase2_Confirmation_JNjK: 'Sí',
  Fleet_Phase1_Payment_Method_wZPV: 'Método de pago',
  Fleet_check_OZWz_BEqb: 'Subir ahora',
  Fleet_replenish__ZOFV: '¡Ocurrió un error! Por favor, inténtalo de nuevo.',
  Fleet_Phase3_Other_jpBw: 'Otro',
  Fleet_Phase1_Unable_to_LSII: 'No se pudo obtener el permiso para notificaciones',
  Fleet_Phase1_Model_tdll: 'Modelo',
  Fleet_Phase3_Unable_to_pVKf: 'Error al llamar. Inténtalo de nuevo.',
  Fleet_Phase3_Set_to_rSJK: 'Definir como predeterminada',
  Fleet_Phase1_Add_your_cKWv: 'Muéstrales tu vehículo a los arrendadores que quieren rentar uno.',
  Fleet_Phase3__CXxw: 'Servicios de localización desactivados',
  Fleet_Phase2_View_Details_MBZa: 'Ver detalles',
  Fleet_Phase1_Type_of_YmjW: 'Tipo de combustible',
  Fleet_Phase3__gvnI: 'No hay resultados',
  Fleet_Mgt_No_more_mlms: 'No hay más datos',
  Fleet_Phase1_Successful_shelves_roWu: 'Se agregó correctamente.',
  Fleet_Phase2_Unable_to_UqWk:
    'No se pudo enviar la invitación. Este arrendador ya es parte de otra flotilla.',
  Fleet_Phase1_Weekly_online_gZHC: 'Horas de conexión semanales',
  Fleet_Phase2_Accept_the_RiKY: 'Aceptar invitación',
  Fleet_FleetRecommendation_Contact_number_yTBC: 'Número de contacto',
  Fleet_Phase3_Public_number_KRCc: 'Mostrar mi número',
  Fleet_Phase1_Introduce_more_WZRj: 'Cuéntanos más sobre ti para que la flotilla pueda conocerte',
  Fleet_Phase1_Add_a_QLhS: 'Agregar currículum',
  Fleet_Phase1_Refresh_iWvD: 'Actualizar',
  Fleet_Phase1_Enter_the_LXDS: 'Ingresa tu nombre.',
  Fleet_Phase1_Go_and_ddqt: 'Ingresar ahora',
  Fleet_deactivation_pIlV_dzGd: 'Este vehículo se quitará pronto',
  Fleet_Phase3__XowH: '¿Seguro que quieres enviar el correo?',
  Fleet_Phase3__Gfwg: 'Cargando',
  Fleet_Phase1_Hand_gear_hAFe: 'Manual',
  Fleet_Phase1_Enter_the_tbQJ: 'Ingresa un monto.',
  Fleet_check_Admw_cABo: 'Ahora no',
  Fleet_Phase2_Contact_the_xIkV: 'Contactar a la flotilla',
  Fleet_Phase2_Action_ZSsi: '¿Qué deseas hacer?',
  Fleet_Phase1_Diesel_rsEa: 'Diésel',
  Fleet_Phase2_Call_yqck: 'Llamar',
  Fleet_Phase1_Other_tQVW: 'Otra información',
  Fleet_Phase1_Collection_XqMI: 'Favoritos',
  Fleet_Phase1_Personal_information_rOpp: 'Información personal',
  Fleet_Phase1_Default_image_AFLD: 'Imágenes predeterminadas',
  Fleet_Phase1_Vehicle_photos_CWvR: 'Fotos del vehículo',
  Fleet_Phase1_Add_more_ykcL:
    'Agrega más datos sobre el vehículo para aumentar las posibilidades de que lo renten.',
  Fleet_Drivers_Save_feyd: 'Guardar',
  Fleet_Phase1_Go_vwbQ: 'Ir',
  Fleet_Phase2_Send_UCas: 'Enviar',
  Fleet_Phase3_Offences_Eyzh: 'Tarifa por infracción vial',
  Fleet_Phase1_Price_JEDD: 'Tarifa',
  Fleet_Phase1_Confirmation_and_UFnR: 'Confirmar y agregar',
  Fleet_Phase1_Add_a_yEOo:
    'Agrega fotos del vehículo para aumentar las posibilidades de que lo renten.',
  Fleet_Phase2_Waiting_for_PGxV: 'Esperando respuesta',
  Fleet_Phase1_Select_model_MskT: 'Elige un tipo de vehículo.',
  Fleet_Phase3_Pick_up_fDQC: 'Dirección del vehículo',
  Fleet_Phase2_Your_vehicle_etii:
    'Tu vehículo {{Vehicle_Plate}} no pasó la revisión. Envía todos los datos y reinténtalo.',
  Fleet_Phase2_Select_vehicle_DmgM: 'Elige un vehículo',
  Fleet_Phase2_Don_t_fbDU: '¿No te quieres perder de los mensajes y novedades?',
  Fleet_Phase3__yPol: 'Por seguridad, los arrendadores no verán la dirección completa.',
  Fleet_Phase3_Show_Name_DTSP: 'Nombre mostrado',
  Fleet_Phase1_Rental_gIKm: 'Tarifa semanal de la renta',
  Fleet_Phase1_No_idle_CWLj: 'No hay vehículos inactivos disponibles.',
  Fleet_Phase2_I_think_iJfP:
    'Creo que mi vehículo cumple con los requisitos que mencionas. ¿Podemos platicar?',
  Fleet_Phase1_Cancel_the_jVMw: 'Se eliminó de tus favoritos.',
  Fleet_Phase1_Week_DoYO: 'semana',
  Fleet_deactivation_IDBa_Nsnf: 'Se quitó este vehículo',
  Fleet_Phase1_Transmission_box_ntTQ: 'Transmisión',
  Fleet_Phase1_Select_Energy_jPEr: 'Elige un tipo de combustible.',
  Fleet_Phase1_shelves_gQRG: 'Agregar',
  Fleet_FleetRecommendation_Enter_the_OAao: 'Ingresa un número de teléfono válido',
  Fleet_Phase2_Invitation_to_XuMK: 'Invitación',
  Fleet_Phase1_Delete_vHOi: 'Eliminar',
  Fleet_Phase2__CV_ufBg: '[Información personal]',
  Fleet_Phase1_The_vehicle_iveG:
    'Vehículo vinculado a un arrendador. Desvincula e intenta de nuevo',
  Fleet_Phase3_No_pickup_yaXi: 'No has agregado direcciones',
  Fleet_Phase2_Get_a_ViuM: 'Ver información',
  Fleet_Phase1_Star_rating_LMKh: 'Calificación',
  Fleet_Phase1_Energy_PPWp: 'Tipo de combustible',
  Fleet_Phase1_More_information_QGAV: 'Más información',
  Fleet_Phase2_Unable_to_Mpfg:
    'No se pudo enviar la invitación porque la cuenta de este arrendador está bloqueada temporalmente.',
  Fleet_Phase1_Exit_olZc: 'Salir',
  Fleet_Phase1_Other_ydLJ: 'Otro',
  Fleet_Phase2_All_BQZQ: 'Todos',
  Fleet_Phase1_Please_select_XUaB: 'Elige las opciones disponibles.',
  Fleet_Phase3_Call_now_MEMz: 'Llamar',
  Fleet_Phase2_Your_vehicle_Rmil: 'Se agregó tu vehículo con placas {{Vehicle_Plate}}',
  Fleet_Phase1_Home_Page_ezjA: 'Inicio',
  Fleet_check_XKad_fPlI: 'Vuelve a subir tu foto de perfil',
  Fleet_Phase2_Are_you_uNIJ: '¿Seguro que quieres eliminar este chat de la lista?',
  Fleet_Phase1__One_ZBrR: '(tarifa por única vez)',
  Fleet_Phase1_It_s_wzyX: 'No hay más datos',
  Fleet_Phase3__cYdF: 'Ir a revisión de documentos',
  Fleet_Phase1_The_vehicle_cZTB: 'Se quitó el vehículo. Por favor, agrégalo de nuevo.',
  Fleet_Phase1_Take_a_SlkQ: 'Tomar fotos',
  Fleet_report_Division_Information_capz: 'Info del arrendador',
  Fleet_Phase3_Hidden_Number_tNmI: 'Ocultar mi número',
  Fleet_Phase1_My_message_SfLZ: 'Mi información',
  Fleet_Phase3__jxmA: 'Correo elect.',
  Fleet_Phase2_I_invite_jgxW: '¿Quieres unirte a mi flotilla?',
  Fleet_Phase1_Mixed_aWEq: 'Híbrido',
  Fleet_Phase2__Fleet_RTrK: '{{Fleet_Name}} te invitó a su flotilla',
  Fleet_Phase1_Upload_your_NZFc: 'Carga los documentos del vehículo.',
  Fleet_Phase3__xZGP: 'Resultado de la revisión',
  Fleet_Phase2__Vehicle_mAIO: '[Modelo: {{Vehicle_Model}}]',
  Fleet_Phase3__lTOd: 'Los documentos no se cargaron o no se aprobaron',
  Fleet_Phase1_The_driver_pCZd:
    'Los arrendadores pueden escribirte directamente a este correo electrónico.',
  Fleet_Phase3_User_Services_wNXe: 'Términos y Condiciones',
  Fleet_Phase3_Deposit_TMrZ: 'Depósito',
  Fleet_Drivers_Go_Settings_vpjg: 'Configuración',
  Fleet_Phase2_Open_notification_kirV: 'Activa las notificaciones para recibir mensajes y noticias',
  Fleet_Phase1_Message_iuXA: 'Mensajes',
  Fleet_Phase2_Unable_to_jWPV:
    'No se pudo aceptar la invitación. Es necesario que primero tengas tus documentos revisados.',
  Fleet_Phase1_Year_uoao: 'año(s)',
  Fleet_Phase1_Cancel_JTqC: 'Cancelar',
  Fleet_Phase3_Unable_to_nWie: 'No se puede agregar.',
  Fleet_Phase1_Idle_GiMD: 'Periodo de inactividad',
  Fleet_Phase3__LovJ: 'Salir',
  Fleet_Phase1_Oil_to_UJTc: 'Aceite y gasolina',
  Fleet_Phase1_You_can_zwFo: 'También puedes agregar vehículos inactivos.',
  Fleet_Phase1_Single_amount_mreo: 'Arrendamientos',
  Fleet_MatchingTool_Confirmation_sFAu: 'Aceptar',
  Fleet_check_uiYb_OxPW:
    'Tu foto de perfil fue rechazada {{reject_max_time}} veces. Para usar esta función, sube una foto válida y espera la aprobación.',
  Fleet_Phase3_Cost_type_DhmU: 'Tipo de tarifa',
  Fleet_Phase1_Select_one_YoKe: 'Selecciona una opción',
  Fleet_Phase3_Coming_up_Vjsn: 'Esta llamada estará cifrada',
  Fleet_MatchingTool_Cancel_Wqtt: 'Cancelar',
  Fleet_FMS_Verification_failed_dRqq: 'No aprobado',
  Fleet_Phase2_Driver_Message_UxZf: 'Mensajes de arrendadores',
  Fleet_Phase1_Mileage_in_vScJ: 'Kilometraje',
  vehicle_info: 'Info. del vehículo',
  small: 'La imagen debe ser menor a 3 MB',
  Fleet_NewPaymentFlow__GUTP: 'One-time Fee',
  Fleet_NewPaymentFlow__NhvB:
    'Amount: {{Price}}. Charged from: {{begin_datetime}}. Frequency: {{Frequency}}.',
  Fleet_NewPaymentFlow__qyoQ:
    '{{Expenses_type}} will be automatically deducted from your Wallet. Frequency: {{Frequency}}.',
  Fleet_NewPaymentFlow_TSCH_mgfl:
    'You’ll need to collect rental fees and other expenses from the driver offline',
  Fleet_NewPaymentFlow_svTo_tbpj: 'To change the collection method, please go to Me > Settings',
  Fleet_NewPaymentFlow__JGoj: 'Collection Method',
  Fleet_NewPaymentFlow__Wzlo: 'Set up rental fees and other expenses',
  Fleet_NewPaymentFlow_lHPn_FNIg: 'Please enter an expense name',
  GDriver_Name_99_mpNh: '99',
  Fleet_NewPaymentFlow__GCoA: 'Effective Date',
  Fleet_EContract_Email_mdfN: 'Email',
  Fleet_NewPaymentFlow__ZQOF: 'Next',
  Fleet_NewPaymentFlow__AMrP:
    'You’ll need to collect rental fees and other expenses from the driver offline',
  Fleet_0303_Fleet_WorkRegime_Withdrawal_oCRI: 'Driver Withdrawal',
  Fleet_NewPaymentFlow__TkSG: 'Contact Fleet',
  Fleet_NewPaymentFlow_sKlJ_uHRX: 'Expense {{num}}',
  Fleet_NewPaymentFlow__aQyj: 'Add Other Expenses',
  Fleet_0303_Fleet_WorkRegime_Car_front_XMgw: 'Driver Reward Paid by Fleet',
  Fleet_NewPaymentFlow__upZL: 'Expense Type',
  Fleet_NewPaymentFlow__ZwVw: 'Expenses will become effective starting on {{Effective_date}}',
  Fleet_Phase1_Boleto_FURd: 'Boleto',
  Fleet_NewPaymentFlow_CAbk_WnqE:
    'Rental fees and other expenses will be collected automatically from the driver’s Wallet. If they don’t have sufficient balance, you’ll need to collect the rest from the driver offline',
  Fleet_NewPaymentFlow__GiSP: 'Effective Date',
  Fleet_0303_Fleet_WorkRegime_Rental_fares_pUsF: 'Vehicle Rental',
  Fleet_tool_HivM_XeKG:
    'Please consider the reliability of information received from outside the {{brand_name}} platform and beware of false information.',
  Fleet_NewPaymentFlow__vurJ:
    'Automatic Collection: Rental fees and other expenses will be deducted automatically from your Wallet. If your balance is insufficient, you’ll need to pay the rest to the fleet partner offline',
  Fleet_NewPaymentFlow__ltIu:
    'Rental fees and other expenses will be collected automatically from the driver’s Wallet. If they don’t have sufficient balance, you’ll need to collect the rest from the driver offline',
  Fleet_NewPaymentFlow__cGLW:
    'Please note that after you accept an invitation and successfully join a fleet, the fleet partner will be able to add or edit an expense without further confirmation from you.',
  Fleet_NewPaymentFlow__wclB:
    'Please read and confirm the rental fees and other expenses info. Tap Accept to join the fleet',
  Fleet_NewPaymentFlow__BFLZ: 'Next',
  Fleet_NewPaymentFlow_OSHq_PQkz: 'Please select a vehicle',
  Fleet_NewPaymentFlow__ydGV: 'Rental Info',
  Fleet_NewPaymentFlow__yzdB: 'Vehicle Details',
  Fleet_NewPaymentFlow__QXtF: 'Monthly',
  Fleet_NewPaymentFlow__PRyq: 'Daily',
  Fleet_NewPaymentFlow__Khbs: 'Automatic',
  Fleet_0303_Fleet_WorkRegime_Driver_Recharge_jdnd: 'Driver Refill',
  Fleet_NewPaymentFlow__bEhi:
    'Rental fees and other expenses will be automatically deducted from your Wallet',
  Fleet_NewPaymentFlow_kWOv_gcBa: 'Please select',
  Fleet_v2_Successfully_saved_SuWc: 'Saved successfully',
  Fleet_NewPaymentFlow__EBXA:
    'Offline Collection: You will need to pay rental fees and other expenses to the fleet partner offline',
  Fleet_NewPaymentFlow__xLMz:
    'Rental fees and other expenses will need to be settled with the fleet partner offline',
  Fleet_NewPaymentFlow__TGeN: 'Expense Collection Method',
  Fleet_0303_Fleet_WorkRegime_drawn_front_MIbK: 'Fleet 0% Commission Card Purchase',
  Fleet_0303_Fleet_WorkRegime_Car_wash_XdSy: 'Cleaning Fee',
  Fleet_NewPaymentFlow__OEob:
    '{{Expenses_type}} will be deducted from your Wallet with a one-time payment',
  Fleet_NewPaymentFlow__BevI: 'Weekly',
  Fleet_0303_Fleet_WorkRegime_Other_items_zPbu: 'Other',
  Fleet_0303_Fleet_WorkRegime_Oil_PGEr: 'Refueling Fee',
  Fleet_0303_Fleet_WorkRegime_lease_fee_hIok: 'Phone Rental',
  Fleet_NewPaymentFlow__tgtT: 'Rental Fee',
  Fleet_Phase3_GNV_amUx: 'GNV',
  Fleet_Phase3_Integrated_sorting_uksd: '',
  Fleet_NewPaymentFlow_mzMZ_ChLK: 'Please enter',
  Fleet_NewPaymentFlow__BVvn: 'Offline',
  Fleet_NewPaymentFlow__Mhyi: 'Delete'
};
